import { render, staticRenderFns } from "./PhilLanding.vue?vue&type=template&id=6b413e55&"
import script from "./PhilLanding.vue?vue&type=script&lang=js&"
export * from "./PhilLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports